<template>
  <div class="product-detail">
    <a-card title="操作日志详情" size="small" style="width: 80%; margin: 1% auto">
      <a-descriptions bordered size="small">
        <a-descriptions-item label="操作模块">
          {{ $constRepository.opertaionLog.getOperationLogModuleNameByLabel(operationLogData.operationLogModule) }}
        </a-descriptions-item>
        <a-descriptions-item label="操作类型">
          {{ $constRepository.opertaionLog.getOperationLogTypeNameByLabel(operationLogData.operationLogType) }}
        </a-descriptions-item>
        <a-descriptions-item label="操作对象ID">
          {{ operationLogData.operationOpenId ? operationLogData.operationOpenId : '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="操作人">
          {{ operationLogData.operationName ? operationLogData.operationName : '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="操作内容" :span="2">
          {{ operationLogData.operationLogContent + `${operationLogData.objectInfoName ? (`[${operationLogData.objectInfoName}]`) : ''}` }}
        </a-descriptions-item>
        <a-descriptions-item label="操作时间">
          {{
            operationLogData.operationTime ? moment(operationLogData.operationTime).format('YYYY-MM-DD HH:mm:ss') : '-'
          }}
        </a-descriptions-item>
        <a-descriptions-item label="操作状态">
          {{ $constRepository.opertaionLog.getOperationLogResultNameByLabel(operationLogData.operationLogResult) }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <a-card size="small" title="请求报文" style="width: 80%; margin: 0 auto; margin-bottom: 1%">
      <vue-json-editor
        v-model="operationLogData.operationPayloadJson"
        :showBtns="false"
        :mode="'code'"
        lang="zh"
        style="height: 300px"
      />
    </a-card>
    <a-card size="small" title="修改项" style="width: 80%; margin: 0 auto; margin-bottom: 1%">
      <a-table size="small" :pagination="true" :data-source="diffObjectList">
        <a-table-column title="修改项" key="keyName" align="center" width="10%">
          <template slot-scope="scope">
            {{ scope.keyName ? scope.keyName : scope.key }}
          </template>
        </a-table-column>
        <a-table-column title="原值" key="oldValue" align="center" width="45%">
          <template slot-scope="scope">
            {{ scope.oldValueName ? scope.oldValueName : scope.oldValue }}
          </template>
        </a-table-column>
        <a-table-column title="新值" key="newValue" align="center" width="45%">
          <template slot-scope="scope">
            {{ scope.newValueName ? scope.newValueName : scope.newValue }}
          </template>
        </a-table-column>
      </a-table>
    </a-card>
    <a-button type="primary" style="margin-top: 1%; margin-left: 10%" @click="$router.back()">返回</a-button>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor';
import moment from 'moment';
import operationLog from '../../../data/const/operationLog';

export default {
  name: 'OperationLogDetail',
  components: {
    vueJsonEditor,
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.fetchOperationLogById(this.$route.params.id);
    }
  },
  data() {
    return {
      operationLogData: {},
      moment,
      diffObjectList: [],
      previewVisible: false,
    };
  },
  methods: {
    async fetchOperationLogById(id) {
      const response = await this.$apiManager.operationLog.getOperationLogById(id);
      this.operationLogData = response.data;
      this.operationLogData.operationPayloadJson = JSON.parse(this.operationLogData.operationPayload || '{}');
      this.operationLogData.operationOldData = JSON.parse(this.operationLogData.operationOldData || '{}');
      this.operationLogData.operationNewData = JSON.parse(this.operationLogData.operationNewData || '{}');
      this.diffObjectList = operationLog.transOperationLogDifferent(
        this.operationLogData.operationLogModule,
        this.operationLogData.operationOldData,
        this.operationLogData.operationNewData,
      );
    },
    async handlePreview(file) {
      const imageFile = file;
      if (!imageFile.url && !imageFile.preview) {
        imageFile.preview = await this.getBase64(imageFile.originFileObj);
      }
      this.previewImage = imageFile.url || imageFile.preview;
      this.previewVisible = true;
    },
    cancel() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.jsoneditor-poweredBy {
  display: none;
}

// /deep/.jsoneditor-outer {
//   height: 25vw;
// }
/deep/ .jsoneditor-vue {
  height: 100%;
}

.green-btn {
  color: green;
  border: none;
}

.loadDevice_title {
  margin-top: 4%;
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5;
}

.product_configuration {
  margin-top: 1%;
}

.product_service {
  margin-top: 1%;
}

.loadDevice_description {
  margin-top: 1%;
}

.product-detail {
  /deep/ .ant-descriptions-row {
    width: 100%;
    word-break: break-all;

    .ant-descriptions-item-label {
      width: 170px;
    }

    .ant-descriptions-item-content {
      width: 200px;
    }
  }
}
</style>
